import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import bgCorporate from '../../assets/failed_url.svg';
import { httpOnlySecurityService } from '../../application/iam';

const LoginFailed: React.FC = () => {
  const { t } = useTranslation();

  const handleLogout = () => {
    httpOnlySecurityService.logout();
  };

  return (
    <Box
      data-testid="login-failed-page"
      sx={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box
        component="img"
        src={bgCorporate}
        alt={t('error.backgroundImage')}
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          opacity: 0.4,
          zIndex: 0,
        }}
      />

      {/* Content */}
      <Container 
        maxWidth={false}
        data-testid="login-failed-container"
        sx={{ 
          flex: 1, 
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '100vh',
          px: 2
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            flex: 1,
            pt: 4,
          }}
          data-testid="login-failed-content"
        >
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom 
            sx={{ 
              color: '#063142', 
              fontWeight: 'bold',
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
              mb: 3
            }}
            data-testid="login-failed-title"
          >
            {t('error.somethingWentWrong')}
          </Typography>

          <Typography 
            variant="body1" 
            sx={{ 
              mt: 2, 
              mb: 4, 
              maxWidth: 900,
              fontSize: { xs: '0.875rem', sm: '1rem' },
              px: 2,
              lineHeight: 1.6
            }}
          >
            {t('error.contactSupport')}&nbsp;
            <a href="mailto:servicedesk@ipc.be" style={{ color: '#063142', textDecoration: 'underline' }}>
              {t('common.serviceDeskEmail')}
            </a>
            &nbsp;{t('common.or')}&nbsp;
            <a href="https://servicedesk.ipc.be/servicedesk" style={{ color: '#063142', textDecoration: 'underline' }}>
              {t('common.servicePortal')}
            </a>
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, mt: 2 }} data-testid="login-failed-actions">
            <Button
              component={Link}
              to="/"
              variant="contained"
              sx={{
                bgcolor: '#E6EEF2',
                color: '#063142',
                '&:hover': {
                  bgcolor: '#d5e3e9'
                },
                px: 4,
                py: 1
              }}
              data-testid="login-failed-home-button"
            >
              {t('common.backToHome')}
            </Button>
            <Button
              variant="contained"
              sx={{
                bgcolor: '#E6EEF2',
                color: '#063142',
                '&:hover': {
                  bgcolor: '#d5e3e9'
                },
                px: 4,
                py: 1
              }}
              onClick={handleLogout}
              data-testid="login-failed-logout-button"
            >
              {t('auth.logout')}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginFailed; 